import styled, { css } from 'styled-components';

export default styled.h2`
  margin: 0;
  font-size: 1.556rem;
  text-transform: uppercase;
  ${({ $useTheWhiteColor }) => $useTheWhiteColor && css`
    color: white;
  `}
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    font-size: 2rem;
  }
`;
